import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
// import { this.props.history } from 'react-router';
import { bindActionCreators } from 'redux';
import * as appointmentActions from '../../../actions/appointmentActions';
import Pagination from "react-js-pagination";
import Moment from 'react-moment';
import 'react-confirm-alert/src/react-confirm-alert.css';
// import ReactTooltip from 'react-tooltip';
import AppointmentDocs from '../../sitemanagement/appointmentDocs';
import AppointmentSym from '../../sitemanagement/appointmentSyms';

const size = 10;
const styleIcon = {
	// paddingRight: 10,
	cursor: 'pointer'
}
class PatientAppointmentHistory extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			patientAllHistory: [],
			sortColumnName: '',
			sortOrder: -1,
			activePage: 1,
			count: size,
			symModal: false,
			totalCount: size
		}
		this.handlePageChange = this.handlePageChange.bind(this);
		this.goToViewConsultation = this.goToViewConsultation.bind(this);
		this.hidedocModal = this.hidedocModal.bind(this);
		this.sortChanged = this.sortChanged.bind(this);
		this._sortClass = this._sortClass.bind(this);
		this.appointmentSymptoms = this.appointmentSymptoms.bind(this)
		this.hidesymModal = this.hidesymModal.bind(this)
	}
	handlePageChange(pageNumber) {
		this.setState({ activePage: pageNumber });
		let appDetail = {
			patientId: this.props.match.params.patientId,
			count: this.state.count,
			page: pageNumber
		}
		this.props.actions.getPatientAllHistory(appDetail);
	}

	componentWillMount() {
		let appDetail = {
			patientId: this.props.match.params.patientId,
			count: this.state.count,
			page: this.state.activePage
		}
		this.props.actions.getPatientAllHistory(appDetail);
	}


	componentWillReceiveProps(nextProps) {
		var state = this.state;
		state.patientAllHistory = nextProps.patientAllHistory.appointmentInfo ? nextProps.patientAllHistory.appointmentInfo : [];
		state.totalCount = nextProps.patientAllHistory.totalCount ? nextProps.patientAllHistory.totalCount : 0;
		this.setState(state);
	}

	appointmentDocuments(data) {
		// console.log(data, "data");
		this.setState({ docModal: true, appointmentId: data._id, patientId: data.patientId })

	}

	appointmentSymptoms(data) {
		this.setState({ symModal: true, appointmentId: data._id, appointmentSymptoms: data.symptoms })

	}

	hidedocModal() {
		this.setState({ docModal: false })
	}

	hidesymModal() {
		this.setState({ symModal: false })
	}

	goToViewConsultation(appointmentId, patientId) {
		localStorage.setItem('patienthistory', 'true')
		localStorage.setItem('patientId', patientId)
		this.props.history.push('/user/appointment-consultation/' + appointmentId);
	}

	sortChanged(sortColumnName, order, e) {
		e.preventDefault();

		this.state.sortColumnName = sortColumnName;
		this.state.page = 1;
		this.state.sortOrder = order == 1 ? -1 : 1;

		let userToken = localStorage.getItem('token');
		let patientId = localStorage.getItem('userId');
		const sorting = {}
		sorting[sortColumnName] = order.toString().toLowerCase() == 1 ? -1 : 1
		this.state.sorting = sorting;


		let appDetail = {
			doctorId: localStorage.getItem('userId'),
			patientId: this.props.match.params.patientId,
			sorting: sorting,
			count: this.state.count,
			page: this.state.activePage
		}
		this.props.actions.getPatientAllHistory(appDetail);

	}

	_sortClass(filterName) {
		return "fa fa-fw " + ((filterName == this.state.sortColumnName) ? ("fa-sort-" + this.state.sortOrder) : "fa-sort");
	}

	getPatientAllHistory = () => {
		let appDetail = {
			patientId: this.props.match.params.patientId,
			count: this.state.count,
			page: this.state.activePage
		}
		this.props.actions.getPatientAllHistory(appDetail);
	}

	render() {
		var patientAllHistory = this.state.patientAllHistory;

		var rows = [];

		return (
			<div className="content-wrapper" >

				{/* this.state.isLoader ? <div className="loaderCenter"> <ReactLoading type={'bars'} color={'blue'} /></div> : */}
				<section className="content container-fluid">
					<div className="row">
						<div className="col-md-12">
							<div className="boxMrgB">
								<div className="nav-tabs-custom">
									<ul className="nav nav-tabs">
										<li><a href="#tab_1" className="active show" onClick={this.getPatientAllHistory} data-toggle="tab" >Appointments</a></li>
									</ul>
									<div className="tab-content" style={{ "minHeight": 410 }}>
										<div className="tab-pane active" id="tab_1">
											<div id="cbp-vm" className="cbp-vm-switcher cbp-vm-view-grid">
												<div className="cbp-vm-options">

												</div>
												<div className="table-responsive">
													<table className="table table-striped table-bordered table-hover">
														<thead>
															<tr>
																<th>
																	Patient
																		{/* <i className={this._sortClass('patient')}></i> */}
																</th>
																<th >
																	Doctor
																		{/* <i className={this._sortClass('doctor')}></i> */}
																</th>
																<th onClick={this.sortChanged.bind(this, 'appointmentDate', this.state.sortOrder)}>
																	Appointment Date
																		<i className={this._sortClass('appointmentdate')}></i>
																</th>
																<th onClick={this.sortChanged.bind(this, 'appointmentTime', this.state.sortOrder)}>
																	Appointment Time
																		<i className={this._sortClass('appointmenttime')}></i>
																</th>
																<th onClick={this.sortChanged.bind(this, 'appointmentMode', this.state.sortOrder)}>
																	Mode
																		<i className={this._sortClass('appointmentmode')}></i>
																</th>
																<th onClick={this.sortChanged.bind(this, 'appointmentStatus', this.state.sortOrder)}>
																	Status
																		<i className={this._sortClass('appointmentstatus')}></i>
																</th>
																<th onClick={this.sortChanged.bind(this, 'disputeStatus', this.state.sortOrder)}>
																	Dispute
																		<i className={this._sortClass('appointmentstatus')}></i>
																</th>
																<th >
																	Health Records
																	</th>
															</tr>
														</thead>
														<tbody>
															{
																(patientAllHistory && patientAllHistory.length > 0) ?
																	patientAllHistory.map((item, index) => <tr key={index}>
																		<td>
																			{item.patient[0].email}
																		</td>
																		<td>
																			{item.doctor[0].email}
																		</td>
																		<td>
																			{<Moment format="DD-MMM-YYYY">{item.appointmentDate}</Moment>}
																		</td>
																		<td>
																			{item.appointmentTime}
																		</td>
																		<td>
																			{item.appointmentMode == 1 ? 'F2F' : 'Online'}
																		</td>
																		<td>
																			{item.appointmentStatus == 1 ? 'Not Completed' : ''}
																			{item.appointmentStatus == 2 ? 'Completed' : ''}
																			{item.appointmentStatus == 3 ? 'No show- Specialist' : ''}
																			{item.appointmentStatus == 4 ? 'No show- Patient' : ''}
																			{item.appointmentStatus == 5 ? 'Reserved' : ''}
																			{/* <Link to='/appointmentStatus'>{item.appointmentStatus == 8 ? 'Disputed' : ''}</Link> */}
																		</td>
																		<td>
																			<Link to={ item.disputeStatus == '1' ? `/user/disputes/${item._id}` : '#'}>
																				{/* {item.appointmentStatus == 8 ? 'Disputed' : ''} */}
																				{item.disputeStatus == true ? "true" : "false"}
																			</Link>
																		</td>
																		<td>
																			{/* <a data-tip data-for={'global1' + index}> */}
																			{/* <Link onClick={this.goToViewConsultation.bind(this, item._id, item.patientId)}>
																				<span className="tooltip-custom fadeEffect tisymtomhover" data-title="View Consultation Form">
																					<img style={styleIcon} src={require('../../../images/img/book.png')} />
																				</span>
																			</Link> */}

																			<span onClick={this.goToViewConsultation.bind(this, item._id, item.patientId)} className="tooltip-custom fadeEffect tisymtomhover rightTooltip" data-title="View Consultation Form">
																				<img style={styleIcon} src={require('../../../images/img/book.png')} />
																			</span>

																			{/* </a> */}
																			{/* <ReactTooltip id={'global1' + index} effect='solid'>
																			<p>View Consultation Form</p>
																		</ReactTooltip> */}

																			{/* <a style={styleIcon} data-tip data-for={'global2' + index}>
																			<img src={require('../../images/img/book.png')} onClick={this.appointmentDocuments.bind(this, item)} style={{ 'cursor': 'pointer' }} />
																			{this.state.docModal ? <AppointmentDocs openModal={this.state.docModal} hideConditionModal={this.hidedocModal} appointmentId={this.state.appointmentId} patientId={this.state.patientId} /> : ''}

																		</a>
																		<ReactTooltip id={'global2' + index} effect='solid'>
																			<p>View Uploaded Symptoms</p>
																		</ReactTooltip> */}

																			{/* <a style={styleIcon} data-tip data-for={'global3' + index}> */}
																			<span className="tooltip-custom fadeEffect tisymtomhover rightTooltip" data-title="View Uploaded Documents">
																				<img src={require('../../../images/img/book.png')} onClick={this.appointmentDocuments.bind(this, item)} style={{ 'cursor': 'pointer' }} />
																			</span>
																			{this.state.docModal ? <AppointmentDocs openModal={this.state.docModal} hideConditionModal={this.hidedocModal} appointmentId={this.state.appointmentId} patientId={this.state.patientId} /> : ''}
																			{/* </a>
																		<ReactTooltip id={'global3' + index} effect='solid'>
																			<p>View Uploaded Documents</p>
																		</ReactTooltip> */}

																			{/* <a style={styleIcon} data-tip data-for={'global4' + index}> */}
																			<span className="tooltip-custom fadeEffect tisymtomhover rightTooltip" data-title="View Symptoms">
																				<img src={require('../../../images/img/book.png')} onClick={this.appointmentSymptoms.bind(this, item)} style={{ 'cursor': 'pointer' }} />
																			</span>
																			{this.state.symModal ? <AppointmentSym openModal={this.state.symModal} hideConditionModal={this.hidesymModal} appointmentId={this.state.appointmentId} symptoms={this.state.appointmentSymptoms} /> : ''}

																			{/* </a>
																		<ReactTooltip id={'global4' + index} effect='solid'>
																			<p>View Symptoms</p>
																		</ReactTooltip> */}
																		</td>

																	</tr>)
																	: 'There are no records found'
															}
														</tbody>
													</table>
												</div>	</div>
										</div>
									</div>
								</div>
							</div>
							{(this.state.totalCount && this.state.totalCount > 10) ?
								<div className="row" style={{ 'marginTop': 30 }}>
									<div className="col-sm-5"><div className="showingEntries">Showing {(this.state.activePage * this.state.count) - (this.state.count - 1)} to {(this.state.activePage * this.state.count) > this.state.totalCount ? this.state.totalCount : (this.state.activePage * this.state.count)} of {this.state.totalCount} entries</div></div>
									<div className="col-sm-7 text-right" style={{ "cursor": "pointer" }}>
										<Pagination
											prevPageText='Prev'
											nextPageText='Next'
											hideFirstLastPages
											activePage={this.state.activePage}
											itemsCountPerPage={size}
											pageRangeDisplayed={size}
											totalItemsCount={this.state.totalCount}
											onChange={this.handlePageChange.bind(this)}
										/>
									</div>
								</div> : ''}
						</div>
					</div>
				</section>
				<div className="Copyrightafterlogin">
					<p>Medfix &copy; 2018. All rights reserved</p>

				</div>
			</div>
		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		patientAllHistory: state.appointment.patientAllHistory,
	};
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(appointmentActions, dispatch),

	};
}
export default connect(mapStateToProps, mapDispatchToProps)(PatientAppointmentHistory);
